var _rect, _rect2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgCross = function SvgCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.142,
    height: 12.021
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1883",
    width: 1,
    height: 16,
    rx: 0.5,
    transform: "rotate(-45 .914 .207)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1884",
    width: 1,
    height: 16,
    rx: 0.5,
    transform: "rotate(45 5.657 13.657)"
  })));
};

export default SvgCross;